import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AnalyticsCard } from './AnalyticsCard';
import {
  APPOINTMENTS,
  FOLLOWUPS,
  ROUTE_APPOINTMENTSFollwUps,
  ROUTE_EVENTS,
} from '../../Util/VMConstants';

function MainAnalytics(props) {
  const navigate = useNavigate();
  const {
    enquiries,
    eventsCount,
    appointments,
    todayDate,
    followups,
    canViewEnquiries = true,
    canViewAppointments = true,
  } = props;

  const cards = [];

  if (canViewEnquiries) {
    cards.push(
      <AnalyticsCard
        key="enquiries"
        title="Today's Enquiries"
        value={enquiries?.length || 0}
        icon="/static/today_enquiries.svg"
        iconColor="primary.main"
        onClick={() =>
          navigate({
            pathname: '/' + ROUTE_EVENTS,
            search: `?type=enquiries&date=${todayDate}`,
          })
        }
      />,
      <AnalyticsCard
        key="events"
        title="Today's Events"
        value={eventsCount || 0}
        icon="/static/today_events.svg"
        iconColor="success.main"
        onClick={() =>
          navigate({
            pathname: '/' + ROUTE_EVENTS,
            search: `?type=events&date=${todayDate}`,
          })
        }
      />
    );
  }

  if (canViewAppointments) {
    cards.push(
      <AnalyticsCard
        key="appointments"
        title="Today's Appointments"
        value={appointments?.length || 0}
        icon="/static/today_appts.svg"
        iconColor="secondary.main"
        onClick={() =>
          navigate({
            pathname: '/' + ROUTE_APPOINTMENTSFollwUps,
            search: `?type=${APPOINTMENTS}&date=${todayDate}`,
          })
        }
      />,
      <AnalyticsCard
        key="followups"
        title="Today's Follow-ups"
        value={followups?.length || 0}
        icon="/static/today_followups.svg"
        iconColor="warning.main"
        onClick={() =>
          navigate({
            pathname: '/' + ROUTE_APPOINTMENTSFollwUps,
            search: `?type=${FOLLOWUPS}&date=${todayDate}`,
          })
        }
      />
    );
  }

  if (cards.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: `repeat(${Math.min(cards.length, 4)}, 1fr)`,
        },
        gap: {
          xs: 1.5,
          sm: 1,
          md: 2,
          lg: 2,
          xl: 2,
        },
        mb: 2,
      }}
    >
      {cards}
    </Box>
  );
}

export default MainAnalytics;